export enum TipoLicenca {
    UNIDADE = "UNIDADE",
    CONTA = "CONTA",
    USUARIO = "USUARIO",
    ACCESS_ON = "ACCESS_ON",
    ACCESS_PRO = "ACCESS_PRO",
    PAC_AUTONOMO = "PAC_AUTONOMO"
}
